import { useState } from "react";

import apiCall from "../utilities/auth/apiCall";
import { assessmentEmailReport } from "../utilities/auth/authApi";
import ButtonSubmit from "../utilities/forms/buttonsubmit";


function AssessmentEmailReport(props) {

  // Define variables
  const [buttonLoading, setButtonLoading] = useState(false);
  const [showButton, setShowButton] = useState(true);
  const assessment = props.assessment;
  const code = assessment.code;
  const email = assessment.email;


  // Define functions
  function handleClick() {
    setButtonLoading(true);

    const payload = {
      code: code,
      email: email
    };

    apiCall(assessmentEmailReport, payload).then((response) => {
      if( response.success ) {
        alert('Your report will be emailed to you shortly')
        setShowButton(false);
      } else {
        alert(response.error);
        setButtonLoading(false);
      }
    });
  }


  // Screen components
  let message = 'Click the button below to email yourself a PDF of your Assessment Report.';
  let buttonElement;
  if( showButton ) {
    buttonElement = (
      <ButtonSubmit
        value={'Email Report'}
        handleButtonClick={handleClick}
        loading={buttonLoading}
        title={'Tap to email yourself a PDF of your Assessment Report'}
      />
    );
  } else {
    message = "Success! Your report will be emailed to you soon.";
  }



  return (
    <div class='flex-column my-assessment-body'>
      <h3>Email report</h3>
      <p style={{marginTop: '15px'}}>{message}</p>

      <div style={{marginTop: '30px', marginBottom: '45px'}}>
        {buttonElement}
      </div>
    </div>
  );
}

export default AssessmentEmailReport;